import React from 'react';
import { motion } from 'framer-motion';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const ProgressChart: React.FC = () => {
  const data = [
    { name: 'Mon', services: 4, revenue: 550 },
    { name: 'Tue', services: 3, revenue: 350 },
    { name: 'Wed', services: 5, revenue: 680 },
    { name: 'Thu', services: 7, revenue: 920 },
    { name: 'Fri', services: 5, revenue: 760 },
    { name: 'Sat', services: 8, revenue: 1200 },
    { name: 'Sun', services: 6, revenue: 880 },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.5
      }
    }
  };

  const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
      return (
        <div className="glassmorphic p-2 text-xs rounded-lg">
          <p className="font-semibold">{label}</p>
          <p className="text-accent">Services: {payload[0].value}</p>
          <p className="text-white/80">Revenue: ${payload[1].value}</p>
        </div>
      );
    }
  
    return null;
  };

  return (
    <motion.div 
      className="rounded-xl bg-white/5 backdrop-blur-sm border border-white/10 h-full overflow-hidden"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <div className="p-4 border-b border-white/10 flex justify-between items-center">
        <h3 className="font-semibold">Weekly Performance</h3>
        <div className="flex items-center space-x-2">
          <div className="flex items-center space-x-1">
            <div className="w-3 h-3 rounded-full bg-accent"></div>
            <span className="text-xs text-white/70">Services</span>
          </div>
          <div className="flex items-center space-x-1">
            <div className="w-3 h-3 rounded-full bg-white/40"></div>
            <span className="text-xs text-white/70">Revenue</span>
          </div>
        </div>
      </div>
      
      <div className="p-4 h-[240px]">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart
            data={data}
            margin={{ top: 10, right: 10, left: -20, bottom: 0 }}
          >
            <defs>
              <linearGradient id="colorServices" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#CCFF00" stopOpacity={0.8}/>
                <stop offset="95%" stopColor="#CCFF00" stopOpacity={0}/>
              </linearGradient>
              <linearGradient id="colorRevenue" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#FFFFFF" stopOpacity={0.3}/>
                <stop offset="95%" stopColor="#FFFFFF" stopOpacity={0}/>
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.1)" />
            <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{ fill: 'rgba(255,255,255,0.5)', fontSize: 10 }} />
            <YAxis axisLine={false} tickLine={false} tick={{ fill: 'rgba(255,255,255,0.5)', fontSize: 10 }} />
            <Tooltip content={<CustomTooltip />} />
            <Area 
              type="monotone" 
              dataKey="services" 
              stroke="#CCFF00" 
              fillOpacity={1} 
              fill="url(#colorServices)" 
              animationDuration={1500}
            />
            <Area 
              type="monotone" 
              dataKey="revenue" 
              stroke="rgba(255,255,255,0.7)" 
              fillOpacity={1} 
              fill="url(#colorRevenue)" 
              animationDuration={1500}
              animationBegin={300}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </motion.div>
  );
};

export default ProgressChart;